export const linkedInUrlRegex =
  /^(https?:\/\/)?([a-z0-9-]+\.)?(linkedin\.com\/in\/.+)$/;

export const fullNameRegex = /^(\p{L}{2,}\s)+\p{L}{2,}$/u;

export const nameRegex = /[^A-Za-z\sçãõáéíóúàèìòùâêîôûÇÃÕÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛ]/g;

export const spacesRegex = /\s+/g;
